<!-- <p>sapcases works!</p> -->
<ng-template #PageLoadingTemplate>
    <app-loading-template DisplayText="Please wait while we load SAP Case information" />
</ng-template>
<div class="main-actions-div" *ngIf="dataSourceCases else PageLoadingTemplate">
    <div class="alignRow" style="margin-bottom: 0.5em;">
        <span style="font-size: large; font-weight: bolder;">{{titleText}}</span>
        <span class="toolbar-spacer"></span>

        <span>Showing&nbsp;</span>
        @if (filterQueryParams.all) {<span>ALL&nbsp;</span>}
        @if (filterQueryParams.closed) {<span>'Closed'&nbsp;</span>}
        @if (filterQueryParams.open) {<span>'Open'&nbsp;</span>}
        @if (filterQueryParams.CMMS) {<span>'In CMMS'&nbsp;</span>}
        @if (filterQueryParams.NotCMMS) {<span>'Not In CMMS'&nbsp;</span>}
        <span>Cases</span>

        @if ((formattedStartDate && formattedEndDate)) {
        <span style="margin-left: 0.5em;margin-right: 0.5em;">
            @if (formattedStartDate != formattedEndDate){
            {{ formattedStartDate }} - {{ formattedEndDate }}
            } @else {
            {{formattedStartDate }}
            }
        </span>
        }
        <div class="date-picker-div">
            <button mat-raised-button [matMenuTriggerFor]="timeMenu" #timeTrigger="matMenuTrigger">
                <span>Date Range</span>
                <mat-icon>access_time</mat-icon>
            </button>
            <button mat-raised-button [matMenuTriggerFor]="filterMenu">
                <mat-icon>tune</mat-icon>
                <span>Filters</span>
            </button>
        </div>

        <mat-menu #timeMenu="matMenu">
            <div style="margin: 1em;">
                <app-date-range-picker (datePickerChange)="DatePickerChange($event)"
                    [matMenuTrigger]="timeTrigger"></app-date-range-picker>
            </div>
        </mat-menu>
    </div>
    <div class="filter-div">
        <mat-form-field>
            <mat-label>Search by Location, Asset, Type, or Date Created</mat-label>
            <input matInput [(ngModel)]="filterQueryParams.filter" (keyup)="onQueryParameterChange('filter', $event)"
                placeholder="" #input>
        </mat-form-field>
    </div>
    <div class="table-container">
        <table mat-table matSort #CMMSTable #sortCases="matSort" class="cmmstable" [dataSource]="dataSourceCases"
            [matSortActive]="filterQueryParams.SortColumn || ''"
            [matSortDirection]="filterQueryParams.SortDirection || ''"
            (matSortChange)="onQueryParameterChange('SortColumn',$event)">
            <ng-container matColumnDef="IsOpen">
                <th class="status" mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td class="status" mat-cell *matCellDef="let row"
                    [matTooltip]="row.IsOpen ? 'Open Case' : 'Case Closed: ' + convertEpoch(row.ClosedAt)  "
                    matTooltipClass="no-wrap-tooltip" matTooltipPosition="left">
                    <span class="app-icon--sapCases-{{ row.IsOpen ? 'open' : 'closed' }}"><mat-icon /></span>
                </td>
            </ng-container>

            <ng-container matColumnDef="InCMMS">
                <th class="cmms" mat-header-cell *matHeaderCellDef mat-sort-header >Ack</th>
                <td class="cmms" mat-cell *matCellDef="let row">
                    <span [matTooltip]="row.InCMMS ? 'Acknowledged: ' + convertEpoch(row.CMMSCreatedAt) : ''"
                        matTooltipClass="no-wrap-tooltip">
                        <!-- <mat-icon>{{ row.InCMMS ?
                            'check_box' :
                            'check_box_outline_blank' }}</mat-icon> -->
                        <mat-icon [ngStyle]="{'color': row.InCMMS ? 'lightgreen':'salmon'}">
                            {{row.InCMMS ? 'check' : 'close'}}</mat-icon>
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="CreatedBy">
                <th class="asset" mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
                <td class="asset" mat-cell *matCellDef="let row">
                    <span>{{ row.TriggerID ? 'Auto' : row.UserIDString }}</span>
                </td>
            </ng-container>


            <ng-container matColumnDef="AssetID">
                <th class="asset" mat-header-cell *matHeaderCellDef mat-sort-header>Asset</th>
                <td class="asset" mat-cell *matCellDef="let row"><span>{{ row.Asset.Name }}</span></td>
            </ng-container>

            <ng-container matColumnDef="Trigger">
                <th class="trigger" mat-header-cell *matHeaderCellDef mat-sort-header>Trigger</th>
                <td class="trigger" mat-cell *matCellDef="let row"><span>{{ row.Trigger }}</span></td>
            </ng-container>

            <ng-container matColumnDef="OpenedAt">
                <th class="openedat" mat-header-cell *matHeaderCellDef mat-sort-header>Date Created</th>
                <td class="openedat" mat-cell *matCellDef="let row">
                    <span>{{convertEpoch(row.OpenedAt) }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="Description">
                <th class="description" mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
                <td class="description" mat-cell *matCellDef="let row"><span>{{ row.Description }}</span></td>
            </ng-container>

            <ng-container matColumnDef="CMMSCreatedAt">
                <th class="createdAt" mat-header-cell *matHeaderCellDef mat-sort-header>SAP Date Created</th>
                <td class="createdAt" mat-cell *matCellDef="let row">
                    <span>{{row.InCMMS ? convertEpoch(row.CMMSCreatedAt) : '' }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="Cause">
                <th class="cause" mat-header-cell *matHeaderCellDef mat-sort-header>Cause</th>
                <td class="cause" mat-cell *matCellDef="let row">
                    <span>{{ row.InCMMS ? row.Cause : '' }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="WorkEventCount">
                <th class="work-event-count" mat-header-cell *matHeaderCellDef mat-sort-header>WE Count</th>
                <td class="work-event-count" mat-cell *matCellDef="let row">
                    <span>{{ row.WorkEventCount > 0 ? row.WorkEventCount : '' }}</span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row class="table-row" (click)="goToCaseDetails(row)" style="cursor: pointer;"
                *matRowDef="let row; columns: displayedColumns;">
            </tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="8">
                    @if (input.value == ''){
                    <span>No Data Matching the Filter</span>
                    } @else {
                    <span>No Data Matching the Filter: "{{input.value}}"</span>
                    }
                </td>
            </tr>
        </table>
        <mat-paginator #paginatorCases [pageSizeOptions]="[5, 10, 25, 100]"
            [pageSize]="filterQueryParams.pageSize ?? 10" [pageIndex]="filterQueryParams.pageIndex"
            (page)="onPageChange(paginatorCases,$event)" aria-label="Select page of cases"></mat-paginator>
    </div>
</div>

<mat-menu #filterMenu>
    <div class="filter-menu-div">
        <div class="enabled-switch-div"><span style="margin-right: 0.2em;">All</span></div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()" [(ngModel)]="filterQueryParams.all"
            (change)="onQueryParameterChange('all',$event)" />

        <div class="enabled-switch-div"><span style="margin-right: 0.2em;">In CMMS</span></div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()" [(ngModel)]="filterQueryParams.CMMS"
            (change)="onQueryParameterChange('CMMS',$event)" />

        <div class="enabled-switch-div"><span style="margin-right: 0.2em;">Non In CMMS</span></div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()" [(ngModel)]="filterQueryParams.NotCMMS"
            (change)="onQueryParameterChange('NotCMMS',$event)" />

        <div class="enabled-switch-div"><span style="margin-right: 0.2em;">Open</span></div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()" [(ngModel)]="filterQueryParams.open"
            (change)="onQueryParameterChange('open',$event)" />

        <div class="enabled-switch-div"><span style="margin-right: 0.2em;">Closed</span></div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()" [(ngModel)]="filterQueryParams.closed"
            (change)="onQueryParameterChange('closed',$event)" />
    </div>
</mat-menu>